import React, { useEffect, useState } from "react";
import { useFormInput } from "@/utils";
import { Chart, registerables } from "chart.js";
import { CustomChart } from "./Components/DashBoardChart";
import { DashBoardCountContainer } from "./Components/DashBoardCountContainer";
import { DashBoardCalendar } from "./Components/DashBoardCalendar";
// import { useGetClientNameListQuery } from "@/redux/clientApi";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import { dateFormat } from "@/utils";
import calendarIcon from "@/assets/icons/calendar.svg";

Chart.register(...registerables);

export const Dashboard = () => {
    /* 화면 변수 */
    const { formData, handleChange, setFormData } = useFormInput({
        curSelectedIndex: 0,
        curSelectedId: 0,
        errorMessage: "",
    });
    const { curSelectedIndex, curSelectedId, errorMessage } = formData;

    // const { data: filterData, error: filterError, isLoading: filterLoading } = useGetClientNameListQuery();
    // useEffect(() => {
    //     console.log(filterData?.data.at(0).id);
    //     filterData?.data.length > 0 &&
    //         setFormData((prev) => ({
    //             ...prev,
    //             curSelectedId: filterData?.data.at(0).id,
    //             curSelectedIndex: 0,
    //         }));
    // }, [filterData]);

    const [dateRange, setDateRange] = useState("0");

    // 대시보드 필터
    const [filterDateRange, setFilterDateRange] = useState([null, null]);
    const [filterStartDate, filterEndDate] = filterDateRange;

    const onDateRangeHandler = (type) => {
        setDateRange(type);
        if (type === "0") {
            setFilterDateRange([null, null]);
        }
        if (type === "1") {
            const start = new Date();
            const end = new Date();

            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            setFilterDateRange([start, end]);
        }
        if (type === "2") {
            const start = new Date();
            const end = new Date();

            start.setDate(start.getDate() - start.getDay() + 1);
            end.setDate(start.getDate() + 6);

            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            setFilterDateRange([start, end]);
        }
        if (type === "3") {
            const date = new Date();

            const start = new Date(date.getFullYear(), date.getMonth(), 1);
            const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            setFilterDateRange([start, end]);
        }
    };

    /// JAVASCRIPT <-> APP
    /// JavaScript -> APP
    const sendMessageToFlutter = () => {
        if (window.flutter_inappwebview) {
            window.flutter_inappwebview.callHandler("flutterHandler", { data: "loginPage" });
        } else {
        }
    };

    /// App -> JavaScript
    const receivedMessageFromFlutter = (data) => {
        console.log("Received from Flutter LoginPage CALL");
        if (data === null) return;
        console.log("Received from Flutter:", data);
        const res = JSON.parse(data);
        alert(res);
        alert(res?.uid);
    };
    window.appCall = receivedMessageFromFlutter;
    /// JAVASCRIPT <-> APP

    return (
        <>
            {/*{isError && <Toast visible={true} msg={errorMessage} />}*/}
            {/* <button onClick={sendMessageToFlutter}>로그인</button> */}
            <div className="dashboard container" data-develop="false">
                {/* <div className="dashboard-filter">
                    <div className="filter-row">
                        <div className="filter-item">
                            <div className="item-tab">
                                {filterData?.data?.length > 0 && filterData?.data?.map((item, index) => (
                                    <button key={`client${index}`} type="button"
                                            className={`btn-tab ${curSelectedIndex === index ? "active" : ""}`}
                                            onClick={(e) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    curSelectedId: item.id,
                                                    curSelectedIndex: index,
                                                }))
                                            }}>
                                        {item?.clientCorName}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="dashboard-filter">
                    <div className="filter-row">
                        <div className="filter-item">
                            <div className="item-content">
                                <div className="item-input">
                                    <DatePicker
                                        locale={ko}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={20}
                                        dateFormat="yyyy.MM.dd"
                                        onKeyDown={(e) => e.preventDefault()}
                                        selectsRange={true}
                                        startDate={filterStartDate}
                                        endDate={filterEndDate}
                                        value={filterStartDate && `${dateFormat(filterStartDate)} ~ ${dateFormat(filterEndDate)}`}
                                        onChange={(update) => {
                                            setFilterDateRange(update);
                                        }}
                                    />
                                    <img src={calendarIcon} alt="" />
                                </div>
                                <div className="item-buttons">
                                    <button
                                        type="button"
                                        className={`btn-toggle ${dateRange === "0" ? "active" : ""}`}
                                        onClick={() => onDateRangeHandler("0")}
                                    >
                                        전체
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${dateRange === "1" ? "active" : ""}`}
                                        onClick={() => onDateRangeHandler("1")}
                                    >
                                        당일
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${dateRange === "2" ? "active" : ""}`}
                                        onClick={() => onDateRangeHandler("2")}
                                    >
                                        주간
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${dateRange === "3" ? "active" : ""}`}
                                        onClick={() => onDateRangeHandler("3")}
                                    >
                                        월간
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DashBoardCountContainer clientId={curSelectedId} startedAt={filterStartDate} endedAt={filterEndDate} />

                <DashBoardCalendar clientId={curSelectedId} />

                <CustomChart clientId={curSelectedId} startedAt={filterStartDate} endedAt={filterEndDate} />
            </div>

            {/* 스케쥴 상세 */}
            {/*{scheduleDetailModal && (*/}
            {/*    <ScheduleDetail*/}
            {/*        modalStatus={scheduleDetailModal}*/}
            {/*        setModalStatus={handleScheduleDetailModal}*/}
            {/*        date={selectedDate}*/}
            {/*        data={selectedDetailData}*/}
            {/*    />*/}
            {/*)}*/}
        </>
    );
};
